<template>
  <div class="greetings">
      <p class="title">{{ helloSir }}, <span>{{ name }}</span></p>
      <p class="sub">{{ trans('dashboard.general.greeting') }}</p>
  </div>
</template>

<style lang="scss" scoped >

</style>


<script>

import {trans} from "@common/tsutils/trans";

    export default {

        props: ['name'],

        computed: {
          helloSir() {
            const thresholds = [0, 6, 12, 17, 20];
            const greet = [
                trans('dashboard.insiders.greetings.n'),
                trans('dashboard.insiders.greetings.m'),
                trans('dashboard.insiders.greetings.a'),
                trans('dashboard.insiders.greetings.e'),
                trans('dashboard.insiders.greetings.n')
            ];
            let hour = parseInt(moment(new Date()).format("H"));
            let gap = -1;
            for(let i = 0; i < thresholds.length; i++) {
              if(hour >= thresholds[i] && hour < thresholds[i + 1]){
                gap = i;
                break
              }
              if(hour >= thresholds[thresholds.length - 1]) {
                gap = 4
              }
            }

            return greet[gap];
          }
        },

    }

</script>